"use client";

// React and Next.js core imports
// (none in this case)

// Global styles
// (none in this case)

// Providers/Context
// (none in this case)

// Components
import LoginComponent from "@/components/features/auth/login";

const LoginPage = () => {
  return (
    <LoginComponent />
  );
};

export default LoginPage;
